<template>
  <div class="queue-settings">
    <div class="queue-settings__loader"></div>
  </div>
</template>

<script>
  import tableSettingsController from './table-settings-controller'

  export default {
    mixins: [tableSettingsController]
  }
</script>
